module.exports = __webpack_public_path__ + "static/media/body_detectin_video.1ac145cc.mp4";